import { Overline } from '@ev-tech/ui-core-components/Overline';
import { Headline } from '@ev-tech/ui-core-components/Headline';
import { Copy } from '@ev-tech/ui-core-components/Copy';
import { AiStarGradient } from '@ev-tech/search-modules-shared/Icons';
import { Button as BaseButton } from '@base-ui/react/button';

import { useChatbotSession } from '../../providers/ChatbotProvider';

import styles from './ChatbotWelcome.module.css';

type ChatbotWelcomeProps = {
  suggestions: string[];
  disabled: boolean;
  onSendMessage: (message: string) => void;
};

export const ChatbotWelcome = ({ suggestions, disabled, onSendMessage }: ChatbotWelcomeProps) => {
  const { t } = useChatbotSession();

  return (
    <div className={styles.introduction}>
      <Headline size="h5" as="h3" label={t('chatbot.introductionTitle')} />
      <Copy size="m" text={t('chatbot.introduction')} />
      {suggestions.length > 0 && (
        <div className={styles.suggestions}>
          <Overline as="span" className={styles.overline} text={t('chatbot.suggestions')} />
          <div className={styles.chips}>
            {suggestions.map((prompt) => (
              <BaseButton key={prompt} className={styles.chip} disabled={disabled} onClick={() => onSendMessage(prompt)}>
                <AiStarGradient aria-hidden="true" />
                <Copy as="span" size="m" text={prompt} />
              </BaseButton>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
